import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SL_Grid from '../../components/grid/SL_Grid';
import ClientFilters from './ClientFilters';
import { clientGridColumns } from './grid_columns/client_grid_columns';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import { showErrorMessage } from '../../services/messages';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import Divider from '../../components/divider/Divider';

const ListClients = () => {
  const navigate = useNavigate();
  const { setShowLoading } = useContext(GeneralContext);

  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    loadClients(filters);
  }, []);

  const loadClients = async (filterParams = {}) => {
    setLoading(true);
    try {
      // Envia os filtros diretamente para o backend
      const response = await api.client.list(filterParams);
      setClients(response.data);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_LOAD'));
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (values) => {
    setFilters(values);
    // Envia os filtros para o backend
    loadClients(values);
  };

  const handleClearFilters = () => {
    setFilters({});
    // Recarrega sem filtros
    loadClients({});
  };

  const handleEdit = (record) => {
    navigate(`/clients/${record.id}`);
  };

  const handleCreate = () => {
    navigate('/clients/new');
  };

  const columns = clientGridColumns(handleEdit);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card
        title={displayMessage('CLIENTS')}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreate}
          >
            {displayMessage('NEW_CLIENT')}
          </Button>
        }
      >
        <ClientFilters onFilter={handleFilter} onClear={handleClearFilters} />
        
        <Divider />

        <SL_Grid
          dataSource={clients}
          columns={columns}
          loading={loading}
          rowKey="id"
        />
      </Card>
    </div>
  );
};

export default ListClients;

